import moment from 'moment';
import 'moment/locale/ru';

export default (date: string | null | undefined) => {
  moment.locale('ru');
  if (!date) {
    return undefined;
  }
  return moment(date).format('DD.MM.YYYY');
};
